import React from 'react'
import styled from 'styled-components'

const ContainerTextArea = styled.div`
    background: #F2F2F2;
    display: flex;
    justity-content: center;
    flex-direction: row;
    padding: 6px;
    border-radius: 5px;
    margin: 10px 4px;
    
    > div {
        min-width: 15px;
        margin-left: 5px;
        margin-right: 5px;
    }

    > div svg{
        color: ${p => p.theme.palette.primary.main};
    }

    > textarea{
        width: 100%;
        outline: none;
        border: none;
        background: #F2F2F2;
        padding: 6px;
        min-height: 100px;
        resize: none;
    }
`

interface IOwnProps{
    textHolder: string
    icon?: React.ReactElement
}

const TextareaTC: React.FunctionComponent<IOwnProps> = ({ icon, textHolder, ...props }) => {
  return (
    <ContainerTextArea>
        {!!icon && <div>{icon}</div>}
        <textarea placeholder={textHolder} {...props}></textarea>
    </ContainerTextArea>
  )
}

export default TextareaTC